import { Text } from "@/components/ui";
import { type MassTortMatterSearchStatusCategory } from "@/lib/data/requests";
import {
  MATTER_STATUS_CATEGORY_DISPLAY_LABELS,
  MATTER_STATUS_CATEGORY_OPTIONS,
} from "@/lib/data/static/matterStatics";
import { cn } from "@/lib/utils/cn";

type MassTortMattersSearchBarProps = {
  category: MassTortMatterSearchStatusCategory;
  onMatterStatusCategoryChange: (
    value: MassTortMatterSearchStatusCategory,
  ) => void;
};

export function MassTortMattersSearchBar({
  category: selectedCategory,
  onMatterStatusCategoryChange,
}: MassTortMattersSearchBarProps) {
  return (
    <div
      id="mass-tort-matters-search-bar"
      className="border-border flex gap-6 overflow-x-auto border-b px-4 pt-3"
    >
      {MATTER_STATUS_CATEGORY_OPTIONS.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => {
            onMatterStatusCategoryChange(option);
          }}
          className={cn(
            "border-b-2 border-transparent pb-3 whitespace-nowrap",
            option === selectedCategory
              ? "border-b-foreground"
              : "border-transparent",
          )}
        >
          <Text
            as="span"
            variant={option === selectedCategory ? "body" : "subHeading"}
            className="inline-flex items-center font-semibold"
          >
            {MATTER_STATUS_CATEGORY_DISPLAY_LABELS[option]}
          </Text>
        </button>
      ))}
    </div>
  );
}
